import { create } from 'zustand';

interface AssetDeletionDialogState {
  isOpen: boolean;
  startingCount?: number;
  result?: string;
  startedJobIds: string[];
  open: () => void;
  close: () => void;
  beginStarting: (count: number) => void;
  finishStarting: () => void;
  setResult: (result: string) => void;
  trackStartedJob: (id: string) => void;
  clearStartedJobs: () => void;
}

export const useAssetDeletionDialog = create<AssetDeletionDialogState>(set => ({
  isOpen: false,
  startedJobIds: [],
  open: () => set({ isOpen: true, result: undefined }),
  close: () => set({ isOpen: false }),
  beginStarting: startingCount => set({ isOpen: true, startingCount, result: undefined }),
  finishStarting: () => set({ startingCount: undefined }),
  setResult: result => set({ result }),
  trackStartedJob: id => set(state => ({ startedJobIds: [...state.startedJobIds, id] })),
  clearStartedJobs: () => set({ startedJobIds: [] }),
}));
